import {Injectable} from '@angular/core';
import OverlayModel from '../../../models/overlay.model';
import {FadeService} from './fade.service';
import {AnimationService} from './animation.service';

@Injectable({
    providedIn: 'root'
})
export class AnimationInitService {

    constructor(private fadeService: FadeService, private animationService: AnimationService) {
    }

    createAnimationAndFadeSteps(overlays: Array<OverlayModel>): OverlayModel[] {
        return overlays.map(overlay => {
            overlay.style.opacity = overlay.style.hasOwnProperty('opacity') ? overlay.style.opacity : 1;

            if (overlay.hasOwnProperty('transition')) {
                overlay.transition.start.type = overlay.transition.start.easeType;
                overlay.transition.end.type = overlay.transition.end.easeType;

                overlay.transition.frames = {
                    animationIn: this.fadeService.createFadeInListProgress(overlay),
                    animationOut: this.fadeService.createFadeOutListProgress(overlay)
                };
            }

            if (overlay.hasOwnProperty('animations')) {
                overlay.animations.frames = {
                    animationIn: this.animationService.getObjectWithAnimationInCoordinate(overlay),
                    animationOut: this.animationService.getObjectWithAnimationOutCoordinate(overlay)
                };
            }

            return overlay;
        });
    }
}
